export { default } from './TabItem';
export { TabItemProps } from './TabItem.types';
